import { Injectable } from '@angular/core';
import { EventSourceService } from '@app/core/services/event-source.service';
import { MenuService } from '@app/menu/services/menu.service';
import { CacheService } from '@app/portal/services/cache.service';
import { RevealDetailsService } from '@app/shared/components/reveal-details/reveal-details.service';
import { RegisterCommandsService, SortOrderCommandService } from '@app/shared/quick-commands';
import { PortalNotificationService } from '@business/notification/portal-notification.service';

@Injectable({
  providedIn: 'root',
})
export class InitializerService {
  constructor(
    private cacheService: CacheService,
    private menuService: MenuService,
    private portalNotificationService: PortalNotificationService,
    private registerCommandsService: RegisterCommandsService,
    private revealDetailsService: RevealDetailsService,
    private sseService: EventSourceService,
    private sortOrderCommandService: SortOrderCommandService
  ) {}

  initialize() {
    this.cacheService.initialize();
    this.menuService.initialize();
    this.portalNotificationService.initialize();
    this.registerCommandsService.initialize();
    this.revealDetailsService.initialize();
    this.sseService.initialize();
    this.sortOrderCommandService.initialize();
  }
}
